import type { z } from 'zod';

export interface EndpointDef<
  TMethod extends string = string,
  TPath extends string = string,
  TRequest extends z.ZodTypeAny = z.ZodTypeAny,
  TResponse extends z.ZodTypeAny = z.ZodTypeAny,
> {
  method: TMethod;
  path: TPath;
  requestSchema: TRequest;
  responseSchema: TResponse;
  defaultCredentials?: RequestCredentials;
}

export function endpoint<
  TMethod extends string,
  TPath extends string,
  TRequest extends z.ZodTypeAny,
  TResponse extends z.ZodTypeAny,
>(
  method: TMethod,
  path: TPath,
  requestSchema: TRequest,
  responseSchema: TResponse,
  defaultCredentials?: RequestCredentials,
): EndpointDef<TMethod, TPath, TRequest, TResponse> {
  return { method, path, requestSchema, responseSchema, defaultCredentials };
}
